module.exports = __webpack_public_path__ + "img/12-oneImg.e408d97d.png";